export default __webpack_public_path__ + "static/slide04-daf361b64867b96c70eec230d732445c.jpg";